import React, { useCallback } from "react";
import PropTypes from "prop-types";
import Loader from "react-loaders";
import { useMappedState } from "redux-react-hook";
import NavigationBar from "../../NavigationBar";
import NavFooter from "../../NavFooter";
import SearchContainer from "../../SearchContainer/SearchContainer";
import "./styles.scss";;


const Home = () => {
  const getSearchResults = useCallback(
    ({ profile }) => profile.searchResults,
    []
  );
  const searchResults = useMappedState(getSearchResults);
  const searchLoading = useMappedState(state => state.profile.searchLoading);

  return (
    <div id="home-page">
      <React.Fragment>
        <NavigationBar/>
        {searchLoading && (
          <div id="loader-container">
            <Loader type="ball-grid-pulse" color="#FFC000" active/>
          </div>
        )}
        {!!searchResults.length && !searchLoading && <SearchContainer/>}
        <NavFooter/>
      </React.Fragment>
    </div>
  );
};

Home.propTypes = { searchResults: PropTypes.any };

export default Home;



// WEBPACK FOOTER //
// ./src/components/pages/Home/Home.jsx